import { Component, Input } from "@angular/core";
import {
  isProfessionalProvider,
  isVolunteer,
} from "models/resource-management/company-resource-type-guards";
import CredentialType from "models/resource-management/credential-type.enum";
import CredentialedResource from "models/resource-management/credentialed-resource";
import ProfessionalProvider from "models/resource-management/professional-provider";
import { LookupValue } from "../../../../models/common/lookup-value";
import { ContactType } from "../../../../models/company-resources/contact-type";

@Component({
  selector: "workforce-resources-detail",
  templateUrl: "workforce-resources-detail.html",
})
export class WorkforceResourcesDetailComponent {
  private _resource: CredentialedResource;
  isProvider: boolean = false;
  isVolunteer: boolean = false;
  CredentialType = CredentialType;
  @Input() public createdDate: Date = null;
  @Input() public faxNumber: string = "";
  @Input() public professionalRelationList: LookupValue[] = [];

  constructor() {}

  // region Getters and Setters
  get resource(): CredentialedResource {
    return this._resource;
  }

  @Input()
  set resource(value: CredentialedResource) {
    this._resource = value;
    if (isProfessionalProvider(value)) {
      this.isProvider = true;
    }
    if (isVolunteer(value)) {
      this.isVolunteer = true;
    }
  }

  get provider(): ProfessionalProvider {
    return this.resource as ProfessionalProvider;
  }

  get isEmployee(): boolean {
    return this._resource.isEmployee;
  }

  // endregion

  protected readonly ContactType = ContactType;

  professionalRelation(id: number): LookupValue {
    if (!this.professionalRelationList) {
      return new LookupValue(0, "");
    }
    let professionalRelation = this.professionalRelationList.find(
      (a) => a.id === id
    );
    return professionalRelation ? professionalRelation : new LookupValue(0, "");
  }

  searchContactType(contactType) {
    switch (contactType) {
      case ContactType.PROVIDERS:
        return "Provider";
      case ContactType.NON_PROVIDERS:
        return "Non-Provider";
      case ContactType.VOLUNTEERS:
        return "Volunteers";
      default:
        return "";
    }
  }

  getLocations(): string {
    if (
      this.provider.contactLocations &&
      this.provider.contactLocations.length > 0
    ) {
      return this.provider.contactLocations
        .map((x) => x.displayCode)
        .join(", ");
    }
    return "";
  }

  getUpdatedOrCreatedDateTime(credential) {
    return credential.updatedDatetime
      ? credential.updatedDatetime
      : credential.createdDatetime;
  }

  getUpdatedOrCreatedBy(credential) {
    return credential.updatedBy ? credential.updatedBy : credential.createdBy;
  }
}



// WEBPACK FOOTER //
// ./src/components/system-admin/workforce/workforce-resources-detail/workforce-resources-detail.ts